import { useEffect } from "react";

const COOKIEBOT_SCRIPT_ID = "Cookiebot";
const COOKIEBOT_SRC = "https://consent.cookiebot.com/uc.js";
const COOKIEBOT_CBID = "6c47cfec-b394-4dd0-b585-4921c48e4b89";

/**
 * Loads the Cookiebot consent banner once when the app starts.
 * The script is injected into the document head so the consent dialog
 * covers every page of the site.
 */
export default function CookieConsent() {
  useEffect(() => {
    if (document.getElementById(COOKIEBOT_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = COOKIEBOT_SCRIPT_ID;
    script.src = COOKIEBOT_SRC;
    script.type = "text/javascript";
    script.setAttribute("data-cbid", COOKIEBOT_CBID);
    script.setAttribute("data-blockingmode", "auto");
    document.head.appendChild(script);
  }, []);

  return null;
}